import Layout from '@/pages/datav/layout'
import util from '../utils'
import { Notification } from 'element-ui';

// 系统管理
// const RegionDatav = r => require(['@/pages/datav/region/index'], r)
const RegionDatav = r => require(['@/pages/datav/newregion/index'], r)


export const datav = {
  path: '/region/datav',
  component: Layout,
  meta: { auth: 'Region-Datav' },
  redirect: '/region/datav/index',
  children: [{
    path: '/region/datav/index',
    meta: { auth: 'Region-Datav', keepAlive: true },
    component: RegionDatav
  }]
}


// WEBPACK FOOTER //
// ./src/router/datav.js